export const customerOption = {
	noCustomer: "nocustomer",
	customer: "customer"
}

export const customerTypeOptions = [
	{
		icon: "/assets/icons/customerService/yes-option-icon.svg",
		title: "customer-option-text",
		path: customerOption.customer
	},
	{
		icon: "/assets/icons/customerService/no-option-icon.svg",
		title: "nocustomer-option-text",
		path: customerOption.noCustomer
	}
]

export const formTypeOptions = {
	generalQuestion: "general-question",
	returnBike: "return-bike",
	bikeIssue: "bike-issue",
	arriveDamaged: "arrive-damaged"
}

export const formTypeOptionsList = [
	{
		icon: "/assets/icons/customerService/general-question.svg",
		title: "general-question-label",
		path: formTypeOptions.generalQuestion
	},
	{
		icon: "/assets/icons/customerService/arrive-damaged.svg",
		title: "arrive-damaged-label",
		path: formTypeOptions.arriveDamaged
	},
	{
		icon: "/assets/icons/customerService/bike-issue.svg",
		title: "bike-issue-label",
		path: formTypeOptions.bikeIssue
	},
	{
		icon: "/assets/icons/customerService/return-bike.svg",
		title: "return-bike-label",
		path: formTypeOptions.returnBike
	}
]

export const selectionType = {
	customerTypeSelection: "customerTypeSelection",
	formTypeSelection: "formTypeSelection"
}

export const issueTimeCustomerOptions = [
	{
		icon: "",
		title: "less-24-hours-label",
		path: "less-24-hours"
	},
	{
		icon: "",
		title: "less-7-days-label",
		path: "less-7-days"
	},
	{
		icon: "",
		title: "less-2-4-weeks-label",
		path: "less-2-4-weeks"
	},
	{
		icon: "",
		title: "less-1-month-label",
		path: "less-1-month"
	},
	{
		icon: "",
		title: "more-2-years-label",
		path: "more-2-years"
	}
]
